/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createTheme } from "@mui/material/styles";
import { presetPalettes } from "@ant-design/colors";
// import lightBlue from '@mui/material/colors/lightBlue';
// import blue from '@mui/material/colors/blue';
// import green from '@mui/material/colors/green';
// import lightGreen from '@mui/material/colors/lightGreen';
// import teal from '@mui/material/colors/teal';
// import purple from '@mui/material/colors/purple';
import ThemeOption from "./theme";

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode) => {
    const colors = presetPalettes;

    const greyPrimary = [
        "#ffffff",
        "#fafafa",
        "#f5f5f5",
        "#f0f0f0",
        "#d9d9d9",
        "#bfbfbf",
        "#8c8c8c",
        "#595959",
        "#262626",
        "#141414",
        "#000000",
    ];
    const greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
    const greyConstant = ["#fafafb", "#e6ebf1"];

    colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

    const paletteColor = ThemeOption(colors);

    return createTheme({
        palette: {
            mode,
            common: {
                black: "#000",
                white: "#fff",
            },
            ...paletteColor,
            grey: {
                light: "#f5f5f5",
                main: "#bfbfbf",
                dark: "#595959",
                contrastText: "#000000",
            },
            text: {
                primary: paletteColor.grey[700],
                secondary: paletteColor.grey[500],
                disabled: paletteColor.grey[400],
            },
            action: {
                disabled: paletteColor.grey[300],
                main: "#012861",
                contrastText: "#FFFFFF",
                dark: "#345381",
                light: "#345381",
            },
            divider: paletteColor.grey[200],
            background: {
                paper: paletteColor.grey[0],
                default: paletteColor.grey.A50,
            },
            primary: {
                light: "#345381",
                main: "#012861",
                dark: "#345381",
                contrastText: "#FFFFFF",
            },
            warning: {
                light: "#fcd34d",
                main: "#f59e0b",
                dark: "#b45309",
                contrastText: "#FFFFFF",
            },
            danger: {
                light: "#e10000",
                main: "#C10000",
                dark: "#B70000",
                contrastText: "#FFFFFF",
            },
            
            secondary: {
                light: "#345381",
                main: "#012861",
                dark: "#345381",
                disabled: "#5b535d",
                contrastText: "#FFFFFF",
                background: "#F3F8F9",
            },
            accent: {
                light: "#57f1dd",
                main: "#04C8B1",
                dark: "#00A390",
                // light: "#c026d3",
                // main: "#86198f", 
                // dark: "#4f1252",
                disabled: "#5b535d",
                contrastText: "#FFFFFF",
            },
            neutral: {
                main: "#64748B",
                contrastText: "#fff",
                dark: "#2D2D2D",
            },
            reusable: {
                main: "#86198F",
                light: "#FFF9FF",
            },

            // primary: {
            //     light: lightBlue[700],
            //     main: lightBlue[500],
            //     dark: lightBlue[200],
            //     contrastText: '#FFFFFF',
            // },
            // primary: {
            //     light: lime[700],
            //     main: lime[500],
            //     dark: lime[200],
            //     contrastText: '#FFFFFF',
            // },
            // primary: {
            //     light: '#6de5ff',
            //     main: '#21b3e8',
            //     dark: '#0083b6',
            //     contrastText: '#FFFFFF',
            // },
            // secondary: {
            //     light: teal[700],
            //     main: teal[500],
            //     dark: teal[200],
            //     contrastText: '#FFFFFF',
            // },
            // secondary: {
            //     light: '#71a2eb',
            //     main: '#3b74b8',
            //     dark: '#004988',
            //     contrastText: '#FFFFFF',
            // },
            // success: {
            //     light: lightGreen[700],
            //     main: lightGreen[500],
            //     dark: lightGreen[200],
            //     contrastText: '#FFFFFF',
            // },
        },
    });
};

export default Palette;
